// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_3BWss","container":"index_container_1cQuP","footerNav":"index_footerNav_1kVSU"};